// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","951":"ebe51129","6533":"47d04136"}[chunkId] + ".chunk.css";
};